// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Trip } from '../models/trip.model';
import { CONSTANTS } from './config.service';
import { GeowatcherService } from './geowatcher.service';
import { GisService } from './gis.service';
import { LoggerService } from './logger.service';
import { SqlHelperService } from './sql-helper.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  locationTable = CONSTANTS.locationTableName;
  serverFields = ['*'];
  tripOverviewFields = ['id', 'startTime', 'stopTime', 'startLat', 'startLon', 'locDbName', 'pickupMeters', 'appDied'];

  constructor(
    public platform: Platform,
    private logger: LoggerService,
    private gis: GisService,
    private sqlHelper: SqlHelperService,
    private geowatcher: GeowatcherService
  ) {
    this.logger.log('Storage constructor', MSRemoteLoggerCategory.STORAGE_SERVICE);
  }

  getLatLonFloats(trip, locRow) {
    //let getFloat = this.gis.getFloatLatOrLon;
    return [
      this.gis.getFloatLatOrLon(locRow.latDelta) + this.gis.getFloatLatOrLon(trip.startLat),
      this.gis.getFloatLatOrLon(locRow.lonDelta) + this.gis.getFloatLatOrLon(trip.startLon)
    ];
  }

  getCurrentTripId() {
    if (!CONSTANTS.IS_DEVICE) {
      return Promise.reject(null);
    }
    return this.geowatcher
      .getCurrentTripId()
      .then((id) => (id === -1 ? Promise.reject(null) : Promise.resolve(id)))
      .catch((err) =>
        // console.log('getCurrentTripId reject ', err)
        Promise.reject(err)
      );
  }

  tripInProgress() {
    return this.getCurrentTripId()
      .then((id) => true)
      .catch((err) => false);
  }

  getUnsurveyedTrips(): Promise<any> {
    // ASC id order so we can walk through trips and merge adjacent ones
    // startTime check is a bug patch - in rare cases (restart? re-registration?) we're getting trips w/o start times
    return this.geowatcher.getUnsurveyedTrips();
  }

  getAllTrips(): Promise<Trip[]> {
    return this.geowatcher.getAllTrips();
  }

  hasTrips() {
    if (CONSTANTS.IS_DEVICE) {
      return this.geowatcher.hasTrips();
    } else {
      return Promise.resolve([true]);
    }
  }

  getPointsForTrip(trip, startTime, stopTime, includeTime) {
    const self = this;
    const where = { badLocation: 0 };
    const cols = ['latDelta', 'lonDelta'];

    if (includeTime) {
      cols.push('collectedDelta');
    }

    if (startTime && startTime > trip.startTime) {
      where['collectedDelta_GE'] = startTime - trip.startTime;
    }

    if (stopTime && stopTime < trip.stopTime) {
      where['collectedDelta_LE'] = stopTime - trip.startTime;
    }

    return this.sqlHelper
      .createDb({ name: trip.locDbName, location: 'default' })
      .then((pointDb) => this.sqlHelper.getSelectPromise(pointDb, this.locationTable, cols, where, 'collectedDelta ASC'))
      .then((locations: any[]) => {
        const points = [];
        locations.forEach((location) => {
          const latLon = self.getLatLonFloats(trip, location);
          const point = { lat: latLon[0], lon: latLon[1] };
          if (includeTime) {
            point['time'] = trip.startTime + location.collectedDelta;
          }
          points.push(point);
        });
        return points;
      });
  }

  // includeTime required for finding 'lost' points
  getPointsForTimes(startTime, stopTime, includeTime, includeSplits = false, includeReverses = false) {
    if (!CONSTANTS.IS_DEVICE) {
      return Promise.resolve({ trips: [], locations: [] });
    }
    return this.geowatcher.getPointsForTimes(startTime, stopTime, includeTime, includeSplits, includeReverses);
  }

  // started converting this to backend (in iOS but not Android backend), but I didn't see it used anywhere, so it's commented out for now (2018/6/15)
  //tripStartsWithinStudy(tripId) { return this.geowatcher.tripStartsWithinStudy(tripId) }

  updateHasSurvey(trips) {
    return this.geowatcher.updateHasSurvey(trips);
  }

  getCurrentTripDetails() {
    return this.geowatcher.getCurrentTripDetails();
  }

  deleteAllTrips() {
    return this.geowatcher.deleteAllTrips();
  }

  initialize() {
    //        return this.sqlHelper.createDb({name: CONSTANTS.mainIosDb, location: 'default'})
    //            .then(db => {
    //                this.tripDb = db;
    //            })
  }
  //appVersion = null,

  // cordova.getAppVersion(function (version) {
  // 	appVersion = version;
  // });

  // TODO TEMP for dev - from reinstall, walk and turn off once and use this to test trip continuation
  //sqlHelper.getDeletePromise(tripDb, TRIP_TABLE, {id_GT: 1});
  //sqlHelper.getUpdatePromise(tripDb, TRIP_TABLE, {stopTime: null}, {id: 1});

  // getSeconds = function (location) {
  // 	return Math.floor(location.timestamp / 1000);
  // },

  // countViewableTrips: function () {
  // 	return sqlHelper.getCountPromise(tripDb, TRIP_TABLE, {showInUi: 1});
  // },

  // countNotifiableLongDistanceTrips: function () {
  // 	// notifiable b/c no survey and will not get auto-confirmed
  // 	let highCount = CONSTANTS.surveyAutoConfirmCount,
  // 		notifiable = { showInUi: 1, appDied: 0, locationTimeout: 0, hasSurvey: 0, stopTime_NOTNULL: null, startTime_BETWEEN: [study.getStartSeconds(), study.getStopSeconds()],
  // 			matchedCount0_LT: highCount, matchedCount1_LT: highCount};
  // 	return $q.all([sqlHelper.getCountPromise(tripDb, TRIP_TABLE, angular.extend({splitLat_NULL: null}, notifiable)),
  // 				   sqlHelper.getCountPromise(tripDb, TRIP_TABLE, angular.extend({splitLat_NOTNULL: null}, notifiable))
  // 				])
  // 		.then(function (results) {
  // 			let singleCount = results[0], splitCount = results[1];
  // 			return singleCount + splitCount * 2;
  // 		});
  // },
}
